import React from "react";
import {
  isSanityFormContact,
  isSanityFormPermitRequester,
  isSanityCommunityfundApplicationForm,
  isSanityDynamicForm,
} from "@util/types";
import {
  FormContact,
  FormPermitRequester,
  CommunityFundApplicationForm,
  DynamicForm,
} from "@global";
import {
  Maybe,
  SanityCommunityfundApplicationFormOrDynamicFormOrFormContactOrFormPermitRequester,
} from "@graphql-types";

interface Props {
  data:
    | Maybe<SanityCommunityfundApplicationFormOrDynamicFormOrFormContactOrFormPermitRequester>
    | undefined;
}

function FormSelector({ data }: Props) {
  if (data == null) return null;

  return (
    <>
      {isSanityFormContact(data) && <FormContact data={data} />}
      {isSanityFormPermitRequester(data) && <FormPermitRequester data={data} />}
      {isSanityCommunityfundApplicationForm(data) && <CommunityFundApplicationForm data={data} />}
      {isSanityDynamicForm(data) && <DynamicForm data={data} />}
    </>
  );
}

export default FormSelector;
